import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PATHNAME_KEY = "Pathname-unauthenticated";

export const getPathnameBeforeAuth = () => {
    const { pathname, search } = window.location;
    const pathnameStored = sessionStorage.getItem(PATHNAME_KEY);

    if (!pathnameStored) {
        sessionStorage.setItem(PATHNAME_KEY, pathname + search);
    }
};

export const getPathnameAfterAuth = () => {
    const pathnameStored = sessionStorage.getItem(PATHNAME_KEY);
    sessionStorage.removeItem(PATHNAME_KEY);

    return pathnameStored;
};

export const useRedirectAfterAuth = () => {
    const navigate = useNavigate();
    const pathnameStored = getPathnameAfterAuth();

    useEffect(() => {
        if (pathnameStored && pathnameStored !== "/") {
            navigate(pathnameStored);
        }
    }, [pathnameStored, navigate]);
};
